import { render } from "./documents.vue?vue&type=template&id=5018c088&scoped=true"
import script from "./documents.vue?vue&type=script&lang=js"
export * from "./documents.vue?vue&type=script&lang=js"

import "./documents.vue?vue&type=style&index=0&id=5018c088&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5018c088"]])

export default __exports__